import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.selectItems = [];

    document.querySelectorAll(".c-main-search__select").forEach((item) => {
      this.selectItems.push(new Choices(item, {
        searchEnabled: false,
        placeholder: true,
        shouldSort: true,
        itemSelectText: '',
        dropdownDirection: "down"
      }));
    });

    const performance_kw = document.getElementById("performance_kw");
    const performance_le = document.getElementById("performance_le");

    performance_kw.addEventListener('change', function(e){
      document.getElementById("performance_unit").innerText = 'kW';
    });


    performance_le.addEventListener('change', function(e){
      document.getElementById("performance_unit").innerText = 'LE';
    });
  }

  disconnect() {
    this.selectItems.forEach((item) => {
      item.destroy();
    });
  }
}
